export default __webpack_public_path__ + "static/events-ideas-self-b83fa3ea4caaabc91e10b89df90392e0.jpg";